const costCenterSummary = { data: null, loading: false };
const costCenterDetails = { data: null, loading: false };

export const GetCostCenterSummaryRed = (state = costCenterSummary, action) => {
  switch (action.type) {
    case "get_cost_center_summary":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
export const GetCostCenterDetailsRed = (state = costCenterDetails, action) => {
  switch (action.type) {
    case "get_cost_center_details":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
